<template>
    <div class="check" @click="clicked" @contextmenu.prevent="rightClicked">
        <i v-if="checked" class="fa fa-check"></i>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { globalState } from '@/scripts/store';

const emit = defineEmits(['click','rightClick']);

const props = defineProps({
    checked: Boolean
});

function clicked() {
    emit('click');
}

function rightClicked() {
    emit('rightClick');
}

</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.check {
    width: 30px;
    height: 30px;
    font-size: 14px;
    background-color: $indigo;
    color: white;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    user-select: none;

    &:hover {
        transform: scale(1.2);
    }
}
</style>